import type { SxProps, Theme } from "@mui/material/styles";
import type { ButtonProps } from "@mui/material";

import type { SefanoButtonIntent } from "./SefanoButton.types";

export const root =
  (intent: SefanoButtonIntent, size: ButtonProps["size"] = "medium"): SxProps<Theme> =>
  () => {
    if (size === "small") {
      return {
        width: "auto",
        minWidth: 0,
        py: 0.75,
        px: 2,
        fontSize: "0.8125rem",
      };
    }

    if (intent === "add") {
      return {
        width: "auto",
        minWidth: 206,
        px: 3,
      };
    }

    if (intent === "cancel") {
      return {
        width: "auto",
        minWidth: 170,
        px: 3,
      };
    }

    if (intent === "danger") {
      return {
        width: "auto",
        minWidth: 150,
        px: 3,
        borderWidth: 1.5,
        "&:hover": { borderWidth: 1.5 },
      };
    }

    return {
      width: "auto",
      minWidth: intent === "secondary" ? 170 : 134,
      px: 3,
    };
  };

export const fullWidth: SxProps<Theme> = {
  width: "100%",
  minWidth: 0,
};
